/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/VoucherBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./VoucherBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.VoucherResponse = factory(root.BelfastpilatesProductionappspotcom.ApiClient, root.BelfastpilatesProductionappspotcom.VoucherBean);
  }
}(this, function(ApiClient, VoucherBean) {
  'use strict';




  /**
   * The VoucherResponse model module.
   * @module model/VoucherResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>VoucherResponse</code>.
   * @alias module:model/VoucherResponse
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>VoucherResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/VoucherResponse} obj Optional instance to populate.
   * @return {module:model/VoucherResponse} The populated <code>VoucherResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('discount')) {
        obj['discount'] = ApiClient.convertToType(data['discount'], 'Number');
      }
      if (data.hasOwnProperty('errorCode')) {
        obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
      }
      if (data.hasOwnProperty('hourCheck')) {
        obj['hourCheck'] = ApiClient.convertToType(data['hourCheck'], 'Boolean');
      }
      if (data.hasOwnProperty('hourFrom')) {
        obj['hourFrom'] = ApiClient.convertToType(data['hourFrom'], 'Number');
      }
      if (data.hasOwnProperty('hourTo')) {
        obj['hourTo'] = ApiClient.convertToType(data['hourTo'], 'Number');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('maxUseCount')) {
        obj['maxUseCount'] = ApiClient.convertToType(data['maxUseCount'], 'Number');
      }
      if (data.hasOwnProperty('responseMsg')) {
        obj['responseMsg'] = ApiClient.convertToType(data['responseMsg'], 'String');
      }
      if (data.hasOwnProperty('totalDiscount')) {
        obj['totalDiscount'] = ApiClient.convertToType(data['totalDiscount'], 'String');
      }
      if (data.hasOwnProperty('useCount')) {
        obj['useCount'] = ApiClient.convertToType(data['useCount'], 'Number');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('validFrom')) {
        obj['validFrom'] = ApiClient.convertToType(data['validFrom'], 'Date');
      }
      if (data.hasOwnProperty('validTo')) {
        obj['validTo'] = ApiClient.convertToType(data['validTo'], 'Date');
      }
      if (data.hasOwnProperty('valueOff')) {
        obj['valueOff'] = ApiClient.convertToType(data['valueOff'], 'String');
      }
      if (data.hasOwnProperty('voucherList')) {
        obj['voucherList'] = ApiClient.convertToType(data['voucherList'], [VoucherBean]);
      }
      if (data.hasOwnProperty('voucherName')) {
        obj['voucherName'] = ApiClient.convertToType(data['voucherName'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {Number} discount
   */
  exports.prototype['discount'] = undefined;
  /**
   * @member {Number} errorCode
   */
  exports.prototype['errorCode'] = undefined;
  /**
   * @member {Boolean} hourCheck
   */
  exports.prototype['hourCheck'] = undefined;
  /**
   * @member {Number} hourFrom
   */
  exports.prototype['hourFrom'] = undefined;
  /**
   * @member {Number} hourTo
   */
  exports.prototype['hourTo'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {Number} maxUseCount
   */
  exports.prototype['maxUseCount'] = undefined;
  /**
   * @member {String} responseMsg
   */
  exports.prototype['responseMsg'] = undefined;
  /**
   * @member {String} totalDiscount
   */
  exports.prototype['totalDiscount'] = undefined;
  /**
   * @member {Number} useCount
   */
  exports.prototype['useCount'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {Date} validFrom
   */
  exports.prototype['validFrom'] = undefined;
  /**
   * @member {Date} validTo
   */
  exports.prototype['validTo'] = undefined;
  /**
   * @member {String} valueOff
   */
  exports.prototype['valueOff'] = undefined;
  /**
   * @member {Array.<module:model/VoucherBean>} voucherList
   */
  exports.prototype['voucherList'] = undefined;
  /**
   * @member {String} voucherName
   */
  exports.prototype['voucherName'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/VoucherResponse.js